import React, { useState, useEffect, useCallback } from "react";
import PurchaseCostPanel from "./PurchaseCostPanel";
import ScenarioPanel from "./ScenarioPanel";
import { openCalculator } from "@/lib/evidencePresentation";

export default function FinancialScenarios({
  price,
  propertyType,
  onChange,
  onSummary,
  goal,
  initialInputs,
}) {
  const [purchaseCosts, setPurchaseCosts] = useState(null);
  const [cashflow, setCashflow] = useState(null);
  const updatePurchase = useCallback((result) => {
    setPurchaseCosts(result);
    setCashflow(null);
  }, []);
  useEffect(() => {
    onChange?.(
      purchaseCosts || cashflow
        ? {
            purchase: purchaseCosts?.inputs || null,
            purchase_id: purchaseCosts?.calculation_id || null,
            cashflow: cashflow?.inputs || null,
            cashflow_id: cashflow?.calculation_id || null,
          }
        : null,
    );
  }, [purchaseCosts, cashflow, onChange]);
  useEffect(() => {
    onSummary?.({ purchase: purchaseCosts, cashflow });
  }, [purchaseCosts, cashflow, onSummary]);
  return (
    <>
      <div className="calculator-entry">
        <div>
          <span className="eyebrow">Make your assumptions explicit</span>
          <h2>Build your ownership scenario.</h2>
          <p>
            Start with purchase costs, then explore cash flow and stress tests.
          </p>
        </div>
        <div className="calculator-actions">
          {propertyType !== "house_and_land" && (
            <button
              type="button"
              onClick={() => openCalculator("purchase-calculator")}
            >
              Estimate purchase costs →
            </button>
          )}
          {!["land", "house_and_land"].includes(propertyType) && (
            <button
              className="secondary"
              type="button"
              onClick={() => openCalculator("cashflow-calculator")}
            >
              Model cash flow →
            </button>
          )}
        </div>
      </div>
      {initialInputs && (
        <p className="notice">
          Saved assumptions have been copied into a new draft. Review them,
          confirm the purchase details again and recalculate. Your original
          saved report is unchanged.
        </p>
      )}
      <PurchaseCostPanel
        price={price}
        propertyType={propertyType}
        onResult={updatePurchase}
        initialInputs={initialInputs?.purchase}
      />
      <ScenarioPanel
        price={price}
        propertyType={propertyType}
        purchaseCosts={purchaseCosts}
        onResult={setCashflow}
        initialInputs={initialInputs?.cashflow}
        goal={goal}
        needsPurchase={Boolean(initialInputs?.purchase) && !purchaseCosts}
      />
    </>
  );
}
